import { render, staticRenderFns } from "./Gitlab.vue?vue&type=template&id=e9c89a2a&"
import script from "./Gitlab.vue?vue&type=script&lang=js&"
export * from "./Gitlab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports